<template>
    <el-dialog class="el-dialogs" :append-to-body="true" title="保存" width="400px"
               :close-on-click-modal="false"
               :visible.sync="visible">
        <el-form size="small" :label-position="'top'" ref="savDataafag" :model="savData" :rules="saveRules"
                 @keyup.enter.native="doSubmit()" @submit.native.prevent
                 label-width="110px">
            <el-form-item label="知识模型名称：" prop="name">
                <el-input v-model.trim="savData.modelName" maxlength="20"
                          placeholder="请输入知识模型名称(限20字)"
                          clearable></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="text_right">
            <el-button size="small" @click="visible = false">取消</el-button>
            <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick>保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: "saveDataMy",
    data() {
        return {
            visible: false,
            savData: {
                id: '',
                modelName: '',
            },
            saveRules: {
                modelName: [
                    {min: 0, max: 0, message: '已存在该知识模型名称，请重新输入', trigger: 'change'}
                ],
            },
        }
    },
    methods: {
        init(row) {
            this.savData.modelName = row.modelName
            this.savData.id = row.id
            this.visible = true
        },

        doSubmit() {
            if (this.savData.modelName.length == 0) {
                this.$message.warning('请输入知识模型名称')
                return
            }
            this.$axios(this.api.academic.knowledgemodelOneClickSave, this.savData, 'post').then(data => {
                if (data && data.status) {
                    this.$emit('saveSuccess')
                    this.visible = false
                } else {
                    this.$message.error(data.msg)
                    this.$refs.savDataafag.validate((valid) => {
                    });
                }
            })
        },
    },
}
</script>

<style scoped>

</style>